import React, { useState, useEffect, useRef } from 'react'
import 'katex/dist/katex.min.css'
import 'katex/dist/katex.css'
import * as iink from 'iink-js'
import CanvasDrawing from '../UIUtilsFiles/CanvasDrawing/CanvasDrawing'
import { KnovaText } from '../BasicUIComponents/KnovaText'
import { TrashCan, SendFilled } from '@carbon/icons-react'
import { InlineMath } from 'react-katex'

function SCAnswerPad(props) {
  const {
    isPractice,
    Completed,
    isActive,
    componentData,
    themeColors,
    themeFont,
    themeStyles,
    isSideMenu,
    isFollowTheFlow,
    priorityActive,
    strokeReplayStarted,
    currentSpeed,
    isClassroom
  } = props
  const {
    onValueChange,
    defaultValue,
    onPriorityChange,
    handleSucAndFailFeedback,
    getStrokeReplayFinished,
    onToastTrigger
  } = props
  const { ControlID, Score, CorrectAnswer, Priority, FeedbackAudioData } =
    componentData

  const editorRef = useRef()
  const canvasRef = useRef(null)

  const [isConverted, setIsConverted] = useState(false)
  const [katexData, setKatexData] = useState('')
  const [isAnswered, setIsAnswered] = useState(false)
  //Replay Rectangle data
  const [replayRectangleStrokesData, setReplayRectangleStrokesData] = useState({
    ControlID: 0,
    strokeArray: [],
    strokeActions: []
  })
  const [failureCount, setFailureCount] = useState(0)
  const [onBlurCall, setOnBlurCall] = useState(true)
  const [isInitial, setInitial] = useState(false)

  useEffect(() => {
    if (!isSideMenu) {
      iink.register(editorRef.current, {
        triggers: {
          exportContent: 'DEMAND'
        },
        recognitionParams: {
          type: 'MATH',
          protocol: 'WEBSOCKET',
          server: {
            scheme: 'https',
            host: 'webdemoapi.myscript.com',
            applicationKey: 'b87efc7c-760b-4539-80b0-e5997b4a7905',
            hmacKey: '7cb7fea1-f95b-4842-bf2a-5c033387cf47',
            websocket: {
              alwaysConnected: true
              //   maxRetryCount: 2,
            }
          },
          iink: {
            math: {
              mimeTypes: [
                'application/x-latex',
                'application/vnd.myscript.jiix'
              ],
              solver: {
                enable: false
              }
            },
            export: {
              jiix: {
                strokes: true
              }
            }
          }
        }
      })
    }
  }, [])

  useEffect(() => {
    if (onBlurCall) {
      if (defaultValue && defaultValue !== '') {
        if (defaultValue.CtlSortedArray) {
          setReplayRectangleStrokesData(defaultValue.CtlSortedArray)
        }
        if (defaultValue.CtlValue) {
          setInitial(true)
          let defaultValueSelected = defaultValue.CtlValue
          setKatexData(defaultValueSelected)
        }
      } else {
        setInitial(false)
        setKatexData('')
      }
      setOnBlurCall(false)
    }
  }, [defaultValue, onBlurCall])

  const convert = async () => {
    if (isAnswered) {
      setIsConverted(true)
      editorRef.current.editor.convert()
      editorRef.current.editor.export_()
      console.log('exports convertion')
      editorRef.current.addEventListener('exported', (evt) => {
        const exports = evt.detail.exports
        console.log('exports', exports['application/x-latex'])
        if (exports && exports['application/x-latex']) {
          setKatexData(exports['application/x-latex'])
          validateCorrectAnswer(false, exports['application/x-latex'])
        }
      })
    }
  }

  const clear = () => {
    if (isConverted) {
      editorRef.current.editor.clear()
      setInitial(false)
      setIsConverted(false)
      setIsAnswered(false)
      setKatexData('')
    }
  }

  //Failure message Sequence
  function handleFailureFeedback() {
    let feedbackAudioData = FeedbackAudioData.failureData
    let failureFeedback = {}
    if (feedbackAudioData.length > 0) {
      if (failureCount === 0) {
        setFailureCount(1)
        failureFeedback = feedbackAudioData[0]
      } else if (failureCount === 1) {
        setFailureCount(2)
        failureFeedback = feedbackAudioData[1]
      } else if (failureCount === 2) {
        setFailureCount(0)
        failureFeedback = feedbackAudioData[2]
      }
    } else {
      failureFeedback = {
        failureAudioLink: '',
        failureFeedback: []
      }
    }
    handleSucAndFailFeedback(false, failureFeedback)
  }

  function validateCorrectAnswer(timerValue, optionValue) {
    let correctAnswer = CorrectAnswer
    //Change priority value
    if (onPriorityChange && isFollowTheFlow) {
      if (isPractice) {
        if (optionValue === correctAnswer) {
          onPriorityChange(Priority)
        }
      } else {
        onPriorityChange(Priority)
      }
    }
    if (optionValue === correctAnswer) {
      if (isPractice && isFollowTheFlow) {
        handleSucAndFailFeedback(true, FeedbackAudioData.successData)
      }
    } else {
      handleFailureFeedback()
    }

    if (optionValue === correctAnswer) {
      onValueChange(
        ControlID,
        optionValue,
        Score,
        Score,
        replayRectangleStrokesData,
        timerValue
      )
      if (isPractice) {
      }
    } else {
      onValueChange(
        ControlID,
        optionValue,
        0,
        Score,
        replayRectangleStrokesData,
        timerValue
      )
    }
  }

  function handleReplayAreaData(controlID, strokeData, strokeActions) {
    let replayRectDataCopy = { ...replayRectangleStrokesData }
    replayRectDataCopy.ControlID = controlID
    replayRectDataCopy.strokeArray = strokeData
    replayRectDataCopy.strokeActions = strokeActions
    setReplayRectangleStrokesData(replayRectDataCopy)
  }

  return (
    <div
      className='answer-pad-container'
      style={{
        borderWidth: isSideMenu ? '1px' : '2px',
        borderStyle: isSideMenu ? 'solid' : 'solid',
        borderColor:
          katexData !== ''
            ? katexData === CorrectAnswer
              ? themeColors.success
              : themeColors.error
            : themeColors.outline,
        backgroundColor: themeColors.backgroundContainer,
        borderRadius: isSideMenu ? '5px' : '12px',
        pointerEvents:
          Completed === 1 || !isActive || window.speechSynthesis.speaking
            ? 'none'
            : isFollowTheFlow
            ? isPractice
              ? Priority === priorityActive
                ? 'auto'
                : 'none'
              : Priority > priorityActive
              ? 'none'
              : 'auto'
            : 'auto',
        filter: isFollowTheFlow
          ? Priority <= priorityActive
            ? 'unset'
            : 'blur(3px)'
          : 'unset'
      }}
    >
      <div className='stroke-area-cont'>
        <div
          ref={canvasRef}
          className='sketch-pad-area'
          style={{
            pointerEvents:
              window.speechSynthesis.speaking || Completed === 1 || !isActive
                ? 'none'
                : 'auto'
          }}
        >
          <CanvasDrawing
            fromLayout={true}
            isSideMenu={isSideMenu}
            isAnswerPad={true}
            parentRef={canvasRef}
            initialData={[replayRectangleStrokesData]}
            themeColors={themeColors}
            onSaveData={(updatedStrokes, updatedActions) => {
              if (updatedActions.length > 0) {
                handleReplayAreaData(ControlID, updatedStrokes, updatedActions)
              }
            }}
            currentSpeed={currentSpeed}
            strokeReplayStarted={strokeReplayStarted}
            getStrokeReplayFinished={getStrokeReplayFinished}
            onToastTrigger={onToastTrigger}
            themeFont={themeFont}
          />
        </div>
      </div>
      {/* {!isSideMenu && ( */}
      <div className='answer-area-cont'>
        {isSideMenu || isClassroom || (isInitial && katexData !== '') ? (
          <div
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <InlineMath>{katexData}</InlineMath>
          </div>
        ) : (
          <div
            id='AGInkList'
            onMouseUp={() => {
              setIsConverted(false)
            }}
            onMouseDown={() => {
              setIsAnswered(true)
            }}
            style={{
              width: '100%',
              height: '100%',
              cursor: 'crosshair',
              backgroundColor: 'white'
            }}
            ref={editorRef}
          />
        )}
        {!isAnswered && katexData === '' && (
          <div className='empty-text-cont'>
            <KnovaText
              text='Write your answer here'
              textColor='black'
              textFontSize={isSideMenu ? '8px' : '24px'}
              textFontFamily={themeFont.bodyFont}
              textFontWeight='400'
              textOpacity={0.3}
              textAlign='center'
            />
          </div>
        )}
      </div>
      {/* )} */}

      <div
        className='answer-settings-cont'
        style={{
          display:
            Completed === 1 || !isActive || window.speechSynthesis.speaking
              ? 'none'
              : isFollowTheFlow
              ? isPractice
                ? Priority === priorityActive
                  ? 'flex'
                  : 'none'
                : Priority > priorityActive
                ? 'none'
                : 'flex'
              : 'flex'
        }}
      >
        <div className='answer-btn-cont' onClick={clear}>
          <TrashCan className='ans-btn-style' />
        </div>
        <div className='answer-btn-cont' onClick={convert}>
          <SendFilled className='ans-btn-style' />
        </div>
      </div>
    </div>
  )
}

export default SCAnswerPad
